/* eslint-disable react/display-name */
import { i18nPrefix } from './fleet-overview-i18n'

const fleetOverviewEn = Object.entries({
    'New Rule': 'New Rule',
    'Edit Rule': 'Edit Rule',
    'Fleet Overview Performance': 'Fleet Overview Performance',
    'Asset Control': 'Asset Control',
    'Data Control': 'Data Control',
    Path: 'Path',
    Performance: 'Performance',
    'KPI Context': 'KPI Context',
    'Rigs and Wells': 'Rigs and Wells',
    'Rig Floor': 'Rig Floor',
    'Wells Flat Time': 'Wells Flat Time',
    'Search Items': 'Search Items',
    'Sort by': 'Sort by',
    'Alphabetical - Ascending': 'Alphabetical - Ascending',
    Alphabetical: 'Alphabetical',
    'Alphabetical - Descending': 'Alphabetical - Descending',
    'Select timespan': 'Select timespan',
    'Last 30 days': 'Last 30 days',
    Layout: 'Layout',
    'Filter Result:': 'Filter Result:',
    Quality: 'Quality',
    'Restore default': 'Restore default',
    'Live: Performance UI Overview': 'Live: Performance UI Overview',
    'No results found': 'No results found',
    'Please make a new search': 'Please make a new search',
    'No asset found': 'No asset found',
    'No data': 'No data',
    'This asset has no data available for the selected period.':
        'This asset has no data available for the selected period.',
    selected: 'selected',
    'Unable to execute menu action.': 'Unable to execute menu action.',
    'Open rig actions': 'Open rig actions',
    'Operational Lifecycle': 'Operational Lifecycle',
    'Rig Configuration': 'Rig Configuration',
    'Real time monitoring': 'Real time monitoring',
    'Integration and editing': 'Integration and editing',
    'Operational Analytics': 'Operational Analytics',
    'Standard dashboards': 'Standard dashboards',
    'Dynamic Dashboards': 'Dynamic Dashboards',
    'Compact Card': 'Compact Card',
    'Detailed Card': 'Detailed Card',
    Chart: 'Chart',
    List: 'List',
    'Permission Required': 'Permission Required',
    'To view the chart, you must have one of the following permissions: Admin or Manage Pipe Widgets.':
        'To view the chart, you must have one of the following permissions: Admin or Manage Pipe Widgets.',
    'Back to Performance': 'Back to Performance',
    'Rig name': 'Rig name',
    'Event Integrity': 'Event Integrity',
    'KPI Omission': 'KPI Omission',
    'Data Control and Quality': 'Data Control and Quality',
    Control: 'Control',
    'Dynamic Dashboard Library': 'Dynamic Dashboard Library',
    'Rigs and Wells Fleet Dynamic Dashboard': 'Rigs and Wells Fleet Dynamic Dashboard',
    OLC: 'OLC',
    OA: 'OA',
    RPI: 'RPI',
    Consistency: 'Consistency',
    'Pot. Savings': 'Pot. Savings',
    ILT: 'ILT',
    'Goal Gains': 'Goal Gains'
}).reduce(
    (acc, [key, value]) => ({
        ...acc,
        [`${i18nPrefix}${key}`]: value
    }),
    {}
)

export const enUs = {
    values: {
        'Loading...': 'Loading...',
        'No data found': 'No data found',
        'No data in this range': 'No data in this range',
        'KPI Configuration': 'KPI Configuration',
        'KPI Context': 'KPI Context',
        'Channels interpolation': 'Channels interpolation',
        'KPI generation methodology': 'KPI generation methodology',
        'Event span': 'Event span',
        Status: 'Status',
        'Rig Floor Output Event Type': 'Rig Floor Output Event Type',
        drilling: 'drilling',
        tripping: 'tripping In/Out',
        casing: 'casing',
        'Shifts Configuration': 'Shifts Configuration',
        Color: 'Color',
        'Start.': 'Start',
        End: 'End',
        'Are you sure you want to discard all changes?': 'Are you sure you want to discard all changes?',
        'Are you sure you want to save all changes': 'Are you sure you want to save all changes',
        SAVE: 'SAVE',
        DISCARD: 'DISCARD',
        'Discard changes': 'Discard changes',
        'KPI Channels Configuration': 'KPI Channels Configuration',
        NAME: 'NAME',
        Author: 'Author',
        UNIT: 'UNIT',
        VALUE: 'VALUE',
        'MIN VALUE': 'MIN VALUE',
        TARGET: 'TARGET',
        'MAX VALUE': 'MAX VALUE',
        'CASED HOLE': 'CASED HOLE',
        'OPEN HOLE': 'OPEN HOLE',
        'Last Saved': 'Last Saved',
        'Expand Table': 'Expand Table',
        'discard changes': 'discard changes',
        'No changes to discard': 'No changes to discard',
        'No changes to save': 'No changes to save',
        'Save changes': 'Save changes',
        'GLOBAL CONFIG': 'GLOBAL CONFIG',
        'ADD NEW SHIFT': 'ADD NEW SHIFT',
        'Default Shifts': 'Default Shifts',
        'Please check': 'Please check',
        'Shift with the same color': 'Shift with the same color',
        'Overlaping time': 'Overlaping time',
        'minutes unaccounted for': 'minutes unaccounted for',
        'Fields with empty values': 'Fields with empty values',
        'Something went wrong': 'Something went wrong',
        Shift: 'Shift',
        SHIFTS: 'SHIFTS',
        'KPI PARAMETERS': 'KPI PARAMETERS',
        'GENERAL SETTINGS': 'GENERAL SETTINGS',
        'DRILLING KPIs': 'DRILLING KPIs',
        'CASING KPIs': 'CASING KPIs',
        'TRIPPING KPIs': 'TRIPPING KPIs',
        'Block Weight': 'Block Weight',

        // New
        'Multi KPIs Chart': 'Multi KPIs Chart',
        'Apply Filters': 'Apply Filters',
        Apply: 'Apply',
        Cancel: 'Cancel',
        Reset: 'Reset',
        Histogram: 'Histogram',
        'USER FAVORITES': 'USER FAVORITES',
        'Static Data options are enabled for KPI Data Source and can be turned on or off as you like.':
            'Static Data options are enabled for KPI Data Source and can be turned on or off as you like.',
        'A curve that represents the cumulative frequency distribution of grouped data on a graph.':
            'A curve that represents the cumulative frequency distribution of grouped data on a graph.',
        'Cumulative Distribution Curve': 'Cumulative Distribution Curve',
        'Visualization Options': 'Visualization Options',
        'Number of Bins': 'Number of Bins',
        'Max Value': 'Max Value',
        'Min Value': 'Min Value',
        'Max value cannot be less than Min value.': 'Max value cannot be less than Min value.',
        'Min value cannot be greater than Max value.': 'Min value cannot be greater than Max value.',
        Thresholds: 'Thresholds',
        Start: 'Start',
        'Type to search': 'Type to search',
        ' items selected of ': ' items selected of ',
        Timespan: 'Timespan',
        Intervention: 'Intervention',
        Rigs: 'Rigs',
        Wells: 'Wells',
        'Start with': 'Start with',
        'add percentile mark': 'add percentile mark',
        Period: 'Period',
        'Select a KPI': 'Select a KPI',
        'Select a rig': 'Select a rig',
        'Select a Well': 'Select a Well',
        'All rigs selected': 'All rigs selected',
        'All wells selected': 'All wells selected',
        Type: 'Type',
        Rig: 'Rig',
        Well: 'Well',
        'All timespan selected': 'All timespan selected',
        'One or more fields have an error. Please check and try again.':
            'One or more fields have an error. Please check and try again.',
        'Invalid Time Span': 'Invalid Time Span',
        'Marks on the graph a target mark that allows visualizing and comparing the proximity of the data distribution with the desired target value.':
            'Marks on the graph a target mark that allows visualizing and comparing the proximity of the data distribution with the desired target value.',
        'Displays a curve that describes the frequency distribution of a KPI.':
            'Displays a curve that describes the frequency distribution of a KPI.',
        items: 'items',
        'All intervention selected': 'All intervention selected',
        'Data & Filters': 'Data & Filters',
        'Chart Settings': 'Chart Settings',
        Templates: 'Templates',
        'items selected of': 'items selected of',
        FREQUENCY: 'FREQUENCY',
        CUMULATIVE: 'CUMULATIVE',
        'Type to search...': 'Type to search...',
        Presets: 'Presets',
        'Field is missing, please check and try again.': 'Field is missing, please check and try again.',
        'The amount of data periods that will be analyzed.': 'The amount of data periods that will be analyzed.',
        'All time': 'All time',
        'Last day': 'Last day',
        'Last week': 'Last week',
        'Last 15 days': 'Last 15 days',
        'Last month': 'Last month',
        'Last quarter': 'Last quarter',
        'Last semester': 'Last semester',
        'Last year': 'Last year',
        'Standard Deviation': 'Standard Deviation',
        'Add New Template': 'Add New Template',
        'Template name...': 'Template name...',
        'Save current config': 'Save current config',
        'Save Template': 'Save Template',
        'Cancel changes': 'Cancel changes',
        'Apply Template': 'Apply Template',
        'Edit Template': 'Edit Template',
        'Delete Template': 'Delete Template',
        Edit: 'Edit',
        'Total Stand Time KPI': 'Total Stand Time KPI',
        'tst-off': 'off',
        'tst-on': 'on',
        'This feature allows you to create a Total Stand Time goal. To turn this feature on or off, go to KPI Configuration, choose KPI Goals Settings and the Tripping operation macro.':
            'This feature allows you to create a Total Stand Time goal. To turn this feature on or off, go to KPI Configuration, choose KPI Goals Settings and the Tripping operation macro.',
        'KPI/Channel': 'KPI/Channel',
        'No intervetions selected': 'No intervetions selected',
        'All Timespan selected': 'All timespan selected',
        'Select a chart type...': 'Select a chart type...',
        'You need permission to edit the fields below. Contact the administrator.':
            'You need permission to edit the fields below. Contact the administrator.',
        'Save this widget and return to the dashboard.': 'Save this widget and return to the dashboard.',
        'Filters and settings are displayed in visualization mode only.':
            'Filters and settings are displayed in visualization mode only.',
        Cumulative: 'Cumulative',
        'Select a KPI/Channel': 'Select a KPI/Channel',
        EVENTS: 'EVENTS',
        'Potential Savings': 'Potential Savings',
        'All Rigs': 'All',
        'All Quality': 'All',
        'TARGET(MEDIAN)': 'TARGET(MEDIAN)',
        'POTENTIAL SAVINGS': 'POTENTIAL SAVINGS',
        'BELOW TARGET': 'BELOW TARGET',
        'ABOVE TARGET': 'ABOVE TARGET',
        'TOTAL SAVED': 'TOTAL SAVED',
        TOTAL: 'TOTAL',
        Median: 'Median',
        'Target must be greater than zero': 'Target must be greater than zero.',

        // BOXPLOT
        thresholds: 'thresholds',
        'Min Value': 'Min Value',
        'Max Value': 'Max Value',
        'visualization options': 'visualization options',
        'Dot Values': 'Dot Values',
        Outliers: 'Outliers',
        'Goal/Target': 'Goal/Target',
        'Mean Value': 'Mean Value',
        'Shows a line across the graph, which allows you to view the position of the single Goal/Target for all boxplot in the timespan.':
            'Shows a line across the graph, which allows you to view the position of the single Goal/Target for all boxplot in the timespan.',
        'Shows the value and position of the arithmetic mean in each boxplot.':
            'Shows the value and position of the arithmetic mean in each boxplot.',
        'DATA SOURCE': 'DATA SOURCE',
        'BOXPLOT GROUPS': 'BOXPLOT GROUPS',
        'No option set': 'No option set',
        'Grouping Type': 'Grouping Type',
        'Break Time': 'Break Time',
        Periods: 'Periods',
        'Over Time Comparison': 'Over Time Comparison',
        'Consecutive Break Grouping': 'Consecutive Break Grouping',
        'Cumulative Break Grouping': 'Cumulative Break Grouping',
        'One Boxplot Every': 'One Boxplot Every',
        dayKeyForI18n: 'Day',
        Week: 'Week',
        Month: 'Month',
        Quarter: 'Quarter',
        Semester: 'Semester',
        Year: 'Year',
        'Boxplot was successfully generated with the current config':
            'Boxplot was successfully generated with the current config',
        "Boxplot couldn't be generated": "Boxplot couldn't be generated",
        'You need to configure Boxplot Groups type.': 'You need to configure Boxplot Groups type.',
        'Contact the administrator.': 'Contact the administrator.',
        'Maximum Value': 'Maximum Value',
        'Minimum Value': 'Minimum Value',
        'Upper Quartile': 'Upper Quartile',
        'Lower Quartile': 'Lower Quartile',
        'Number of events': 'Number of events',
        'Mean Value': 'Mean Value',
        Outlier: 'Outlier',
        // BoxPlot Messages error
        'Asset map must not be null.': 'Asset filter must not be null.',
        'Start time must be greater than 0.': 'Start time must be greater than 0.',
        'End time must be greater than 0.': 'End time must be greater than 0.',
        'End time must be after start time.': 'End time must be after start time.',
        'Entity type must not be null.': 'Entity type must not be null.',
        'Entity type filter must not be null or empty.': 'Entity type filter must not be null or empty.',
        'Minimum value must not be null.': 'Minimum value must not be null.',

        // Dictionary
        Entity: 'Entity',
        'Entity Type': 'Entity Type',
        'Generated Token': 'Generated Token',
        'Final Token': 'Final Token',
        'Final token': 'Final token',
        'Last Update': 'Last Update',
        'Dictionary Entries': 'Dictionary Entries',
        'Acronym Dictionary': 'Acronym Dictionary',
        'Code Dictionary': 'Code Dictionary',
        'Code Management': 'Code Management',
        'Manage how codes are displayed across the platform. Changes here override the default mapping defined in the Code Dictionary.':
            'Manage how codes are displayed across the platform. Changes here override the default mapping defined in the Code Dictionary.',
        'kpi description': 'kpi description',
        'display code': 'display code',
        'Search dictionary...': 'Search dictionary...',
        'No dictionary entries found': 'No dictionary entries found',
        'The edited dictionary entry is no longer available. Please refresh the list and try again.':
            'The edited dictionary entry is no longer available. Please refresh the list and try again.',
        'is already in use. Please choose a different token.': 'is already in use. Please choose a different token.',
        'Dictionary entry created successfully.': 'Dictionary entry created successfully.',
        'Dictionary entry updated successfully.': 'Dictionary entry updated successfully.',
        'Dictionary entry deleted successfully.': 'Dictionary entry deleted successfully.',
        'Failed to load dictionary entries.': 'Failed to load dictionary entries.',
        'Failed to create dictionary entry.': 'Failed to create dictionary entry.',
        'Failed to update dictionary entry.': 'Failed to update dictionary entry.',
        'Failed to delete dictionary entry.': 'Failed to delete dictionary entry.',
        edit: 'edit',
        delete: 'delete',
        'Maximum value must not be null.': 'Maximum value must not be null.',
        'Grouping type must not be null.': 'Grouping type must not be null.',
        'Break type must not be null.': 'Break type must not be null.',
        'Break period must not be null.': 'Break period must not be null.',
        'User time zone must not be null or empty.': 'Error getting time zone.',
        'Insufficient memory resources.': 'Insufficient memory resources.',
        'An error occurred.': 'An error occurred.',

        // New
        'Annotation Tool': 'Annotation Tool',
        'Review Options': 'Review Options',
        'Review Option': 'Review Option',
        'Select period': 'Select period',
        'Select asset': 'Select asset',
        'Zoom option: every': 'Zoom option: every',
        'Zoom In': 'Zoom In',
        'Zoom Out': 'Zoom Out',
        'Reset Zoom': 'Reset Zoom',
        Options: 'Options',
        'View Kpis': 'View Kpis',
        'Select method...': 'Select method...',
        'Select method': 'Select method',
        'Sequential Time Review': 'Sequential Time Review',
        'Cutoff Filters (Min, Max, Relative Deviation)': 'Cutoff Filters (Min, Max, Relative Deviation)',
        'Zoom Settings': 'Zoom Settings',
        'Every 15 minutes': 'Every 15 minutes',
        'Every 30 minutes': 'Every 30 minutes',
        'Every Hour': 'Every Hour',
        'Every Two Hours': 'Every Two Hours',
        'Every KPIs': 'Every KPIs',
        'Every 2 KPIs': 'Every 2 KPIs',
        'Every 3 KPIs': 'Every 3 KPIs',
        'Every 5 KPIs': 'Every 5 KPIs',
        'Below Min': 'Below Min',
        'Above Max': 'Above Max',
        Deviation: 'Deviation',
        'TOOLTIP COLOR': 'TOOLTIP COLOR',
        'CHANNEL OPTIONS': 'CHANNEL OPTIONS',
        'KPIS REVIEW PANE': 'KPIS REVIEW PANE',
        'See kpis': 'See kpis',

        'Degree of dispersion of a data set. Indicates how uniform a data set is. The closer to zero the standard deviation, the more homogeneous the data are.':
            'Degree of dispersion of a data set. Indicates how uniform a data set is. The closer to zero the standard deviation, the more homogeneous the data are.',
        'Shows the time sums above and below the target (if there is no target, consider the median). The difference between these values is the total time saved, if greater than zero, or wasted, otherwise.':
            'Shows the time sums above and below the target (if there is no target, consider the median). The difference between these values is the total time saved, if greater than zero, or wasted, otherwise.',
        'Changes applied with success': 'Changes applied with success',
        'Template applied.': 'Template applied.',
        'Current config saved on Template.': 'Current config saved on Template.',
        'For some reason, no shift information was returned. Check your connection and try again later.':
            'For some reason, no shift information was returned. Check your connection and try again later.',
        "For some reason, your request couldn't be saved": "For some reason, your request couldn't be saved",
        'It is not possible to add more than 6 shifts.': 'It is not possible to add more than 6 shifts.',
        'At least one shift has to be configured.': 'At least one shift has to be configured.',
        'Algorithm Thresholds': 'Algorithm Thresholds',
        'Target Settings': 'Target Settings',
        'Value must be bigger than zero': 'Value must be bigger than zero',
        'Value smaller than or equal to min value': 'Value smaller than or equal to min value',
        'Value smaller than or equal to target value': 'Value smaller than or equal to target value',
        'Value larger than or equal to target value': 'Value larger than or equal to target value',
        'Value larger than or equal to max value': 'Value larger than or equal to max value',
        'is a system pattern that can be overriden in each rig parameters.':
            'is a system pattern that can be overriden in each rig parameters.',
        'Default operation shifts should be applied to all active rigs, unless there is a different profile defined here in this section.':
            'Default operation shifts should be applied to all active rigs, unless there is a different profile defined here in this section.',
        'Values set here will affect rig values with overriden parameters which can be accessed on each rig option on the “Operational Targets” tab.':
            'Values set here will affect rig values with overriden parameters which can be accessed on each rig option on the “Operational Targets” tab.',
        "Use this page to configure how crew's shifts should be assingned. The shifts should each have a diferent color and a different time span. No shift can overlap with another. You can configure between 1 and 6 shifts.":
            "Use this page to configure how crew's shifts should be assingned. The shifts should each have a diferent color and a different time span. No shift can overlap with another. You can configure between 1 and 6 shifts.",
        'This time represents the time spent since the operator turns off the pumps until the moment the pump brings the flow again. Actually it is the time without flow rate.':
            'This time represents the time spent since the operator turns off the pumps until the moment the pump brings the flow again. Actually it is the time without flow rate.',
        'This is the time spent in slips and making a connection during tripping operations.':
            'This is the time spent in slips and making a connection during tripping operations.',
        'The Pipe Moving Time represents the time needed for running one stand of drill pipe in or out of the hole. Actually it is the time between two slip to slip connections.':
            'The Pipe Moving Time represents the time needed for running one stand of drill pipe in or out of the hole. Actually it is the time between two slip to slip connections.',
        'This is the average speed the pipe is tripped in or out of the hole as a combination of pipe moving time and in slips time.':
            'This is the average speed the pipe is tripped in or out of the hole as a combination of pipe moving time and in slips time.',
        'The Gross Time per Stand KPI represents the time needed for the pipe to be tripped in or out of the hole as a combination of pipe moving time and in slips time.':
            'The Gross Time per Stand KPI represents the time needed for the pipe to be tripped in or out of the hole as a combination of pipe moving time and in slips time.',
        'This is the time spent in slips during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.':
            'This is the time spent in slips during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.',
        'This is the average speed the joint is moved during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.':
            'This is the average speed the joint is moved during running casing and/or liner (excluding the drill pipe!) in the cased hole or open hole.',
        'This KPI represents the time needed for running one joint of casing/liner into the cased hole. Actually it is the time between two casing/liner slip to slip connections.':
            'This KPI represents the time needed for running one joint of casing/liner into the cased hole. Actually it is the time between two casing/liner slip to slip connections.',
        'The KPI Gross Time per Stand represents the time needed for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time.':
            'The KPI Gross Time per Stand represents the time needed for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time.',
        'This is the average speed the joint is run in the cased hole or open hole as a combination of pipe moving time and in slips time.':
            'This is the average speed the joint is run in the cased hole or open hole as a combination of pipe moving time and in slips time.',
        'This is the rate for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time. Actually it is the Casing – Gross Running Speed divided by an average casing joint length.':
            'This is the rate for a joint to be run in the cased hole or open hole as a combination of pipe moving time and in slips time. Actually it is the Casing – Gross Running Speed divided by an average casing joint length.',
        'Weight to Weight Minimum Flow': 'Weight to Weight Minimum Flow',
        'Weight to Weight Minimum Flow Duration': 'Weight to Weight Minimum Flow Duration',
        'Weight to Weight Off Bottom Threshold': 'Weight to Weight Off Bottom Threshold',
        'Weight to Weight On Bottom Threshold': 'Weight to Weight On Bottom Threshold',
        'Weight to Weight Minimum BPOS': 'Weight to Weight Minimum BPOS',
        'Slip to Slip Minimum HKLD': 'Slip to Slip Minimum HKLD',
        'Slip to Slip Maximum Flow': 'Slip to Slip Maximum Flow',
        'Pump to Pump time': 'Pump to Pump time',
        'Weight to Weight Time': 'Weight to Weight Time',
        'Weight to Slip Time': 'Weight to Slip Time',
        'Slip to Slip Connection Time': 'Slip to Slip Connection Time',
        'Slip to Weight Time': 'Slip to Weight Time',
        'Gross Time per Stand': 'Gross Time per Stand',
        'Gross Drilling ROP per Stand': 'Gross Drilling ROP per Stand',
        'Rotating Drilling Time per Stand': 'Rotating Drilling Time per Stand',
        'Rotating Drilling Meterage per Stand': 'Rotating Drilling Meterage per Stand',
        'Rotating Drilling ROP per Stand': 'Rotating Drilling ROP per Stand',
        'Sliding Drilling Time per Stand': 'Sliding Drilling Time per Stand',
        'Sliding Drilling Meterage per Stand': 'Sliding Drilling Meterage per Stand',
        'Sliding Drilling ROP per Stand': 'Sliding Drilling ROP per Stand',
        'Average Pipe Moving Speed': 'Average Pipe Moving Speed',
        'Pipe Moving Time': 'Pipe Moving Time',
        'Gross Running Speed': 'Gross Running Speed',
        'Gross Running Rate': 'Gross Running Rate',
        'This is the time spent in slips and making a connection during drilling operations:':
            'This is the time spent in slips and making a connection during drilling operations:',
        'A Weight to Weight Connection represents the time between two drilled stands. This KPI starts when the drill string is lifted off from bottom and lasts until the string is on bottom drilling again':
            'A Weight to Weight Connection represents the time between two drilled stands. This KPI starts when the drill string is lifted off from bottom and lasts until the string is on bottom drilling again',
        'The Weight to Slips Time KPI is only calculated during a weight to weight connection. This KPI starts when the bit is lifted off bottom and lasts until the drill string is in slips':
            'The Weight to Slips Time KPI is only calculated during a weight to weight connection. This KPI starts when the bit is lifted off bottom and lasts until the drill string is in slips',
        'The Slips to Weight Time KPI is only calculated during a weight to weight connection. This KPI starts when the drill string is released out of the slips and lasts until the bit is on bottom drilling again.':
            'The Slips to Weight Time KPI is only calculated during a weight to weight connection. This KPI starts when the drill string is released out of the slips and lasts until the bit is on bottom drilling again.',
        'This is the time spent since the pump has been turned off until the pumps come with flow again.':
            'This is the time spent since the pump has been turned off until the pumps come with flow again.',
        'This is the total time needed for drilling one stand of pipe including the weight to weight connection. Actually it covers all time from the end of a weight to weight connection until the end of the subsequent one':
            'This is the total time needed for drilling one stand of pipe including the weight to weight connection. Actually it covers all time from the end of a weight to weight connection until the end of the subsequent one',
        'This KPI is calculated by dividing the drilled distance for one stand of pipe with the Drilling Gross Time KPI.':
            'This KPI is calculated by dividing the drilled distance for one stand of pipe with the Drilling Gross Time KPI.',
        'The Rotating Drilling Time for one stand of pipe represents the time drilling in rotary mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g.wellbore conditioning, toolface orientation, weight to weight connections, etc.).':
            'The Rotating Drilling Time for one stand of pipe represents the time drilling in rotary mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g.wellbore conditioning, toolface orientation, weight to weight connections, etc.).',
        'This is the distance per stand that was drilled in rotary mode.':
            'This is the distance per stand that was drilled in rotary mode.',
        'This is the ROP per stand that was drilled in sliding mode. Actually it is calculated by dividing the Sliding Drilling Meterage with the Sliding Drilling Time.':
            'This is the ROP per stand that was drilled in sliding mode. Actually it is calculated by dividing the Sliding Drilling Meterage with the Sliding Drilling Time.',
        'The Sliding Drilling Time for one stand of pipe represents the time drilling in sliding mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g. wellbore conditioning, toolface orientation, weight to weight connections, etc.)':
            'The Sliding Drilling Time for one stand of pipe represents the time drilling in sliding mode. This covers only the on bottom time and excludes any stops during drilling down a stand (e.g. wellbore conditioning, toolface orientation, weight to weight connections, etc.)',
        'This is the distance per stand that was drilled in sliding mode.':
            'This is the distance per stand that was drilled in sliding mode.',
        'This is the minimum time with pump off without weight on bit.':
            'This is the minimum time with pump off without weight on bit.',
        'This is the minimum distance from the bit to the bottom, to consider that drilling has started or resumed.':
            'This is the minimum distance from the bit to the bottom, to consider that drilling has started or resumed.',
        'This is the maximum distance from the bit to the bottom to consider that it is not drilling.':
            'This is the maximum distance from the bit to the bottom to consider that it is not drilling.',
        'This is the minimum height of the block in relation to the rotary table, to consider that it is not drilling.':
            'This is the minimum height of the block in relation to the rotary table, to consider that it is not drilling.',
        'This is the maximum residual value during connection.':
            'This is the maximum residual value during connection.',
        Clear: 'Clear',
        BROKEN_RULE_1:
            "W2W and P2P aren´t Tripping type KPIs! It's not possible to create a Drilling KPI on this Tripping stand!",
        BROKEN_RULE_2:
            "Tripping in and Tripping Out aren't Drilling type KPIs! It's not possible to create a Tripping KPI on this Drilling stand!",
        BROKEN_RULE_3: "S2S, ROP and Tripping IN/OUT can't occur in multiple Stands!",
        BROKEN_RULE_4: 'W2W and P2P always occurs between exactly two consecutive Stands!',
        BROKEN_RULE_5: "Can't exists multiple occurrences of the same KPI in a unique Stand!",
        BROKEN_RULE_6: "S2S, ROP and TRIPPING IN/OUT can't overlap each others!",
        BROKEN_RULE_7: 'All KPI annotations needs a Stand ID!',
        BROKEN_RULE_8: "Tripping IN KPI can't be created on tripping out (removal) stand!",
        BROKEN_RULE_9: "Tripping OUT KPI can't be created on tripping in (inclusion) stand!",
        INVALID_TRIPPING_DISQUALIFIED: 'Invalid tripping KPI, disqualified event',
        ROP_KPI_MUST_BE_INSIDE_DRILLING_STAND: 'ROP KPI must be inside a drilling stand',
        STAND_TYPE_EMPTY: 'Stand type empty',
        REAL_TIME_AGGREGATION_WARNING:
            'The real time data compression is turned off. No new compressed data is being generated.',
        'Realtime Rig State Channels Configuration': 'Realtime Rig State Channels Configuration',
        'Rate of Penetration': 'Rate of Penetration',
        'Block Position': 'Block Position',
        'Weight on Bit': 'Weight on Bit',
        'SPP Pressure': 'SPP Pressure',
        'Surface Torque': 'Surface Torque',
        'Mud Flow In': 'Mud Flow In',
        Hookload: 'Hookload',
        'Surface RPM': 'Surface RPM',
        'Rig State Channels for Reprocessing': 'Rig State Channels for Reprocessing',
        'KPI GOALS': 'KPI GOALS',
        'New KPI Goal': 'New KPI Goal',
        'Swap KPI Goals': 'Swap KPI Goals',
        // Import/Export KPI Goals CSV
        Operation: 'Operation',
        Unit: 'Unit',
        Goals: 'Goals',
        'Min Cut Off': 'Min Cut Off',
        'Max Cut Off': 'Max Cut Off',
        'Rig Reference Value': 'Rig Reference Value',
        'Import KPI Goals': 'Import KPI Goals',
        'Export KPI Goals': 'Export KPI Goals',
        Import: 'Import',
        Export: 'Export',
        Row: 'Row',
        'Choose which operations to include in the export.': 'Choose which operations to include in the export.',
        'New goals to create': 'New goals to create',
        'Existing goals matched by code': 'Existing goals matched by code',
        'Rows with errors (will be skipped)': 'Rows with errors (will be skipped)',
        'Some rows matched the code of an existing goal. What should we do?':
            'Some rows matched the code of an existing goal. What should we do?',
        'Update the existing goals with the imported values': 'Update the existing goals with the imported values',
        'Skip rows that match an existing goal': 'Skip rows that match an existing goal',
        'more errors': 'more errors',
        'The file has no rows to import.': 'The file has no rows to import.',
        'The file is empty.': 'The file is empty.',
        'KPI Goals configuration is not loaded yet.': 'KPI Goals configuration is not loaded yet.',
        Expected: 'Expected',
        'columns but found': 'columns but found',
        'Missing attribute value in column': 'Missing attribute value in column',
        'Could not match attribute': 'Could not match attribute',
        'Could not match operation': 'Could not match operation',
        'in column': 'in column',
        'Tubular range values must be numbers.': 'Tubular range values must be numbers.',
        'Value for': 'Value for',
        'must be a number.': 'must be a number.',
        'Import finished': 'Import finished',
        created: 'created',
        updated: 'updated',
        skipped: 'skipped',
        failed: 'failed',
        'Customize Rig State Channels for Reprocessing': 'Customize Rig State Channels for Reprocessing',
        'Real time': 'Real time',
        'KPI SERVICE': 'KPI SERVICE',
        'Macro Operation': 'Macro Operation',
        History: 'History',
        'SELECTED CHANNELS': 'SELECTED CHANNELS',
        'KPI Channels': 'KPI Channels',
        'Select KPI channel': 'Select KPI channel',
        'Add channel': 'Add channel',
        'Restore Chart Defaults': 'Restore Chart Defaults',
        Color: 'Color',
        'Custom color': 'Custom color',
        "Couldn't get data on period": "Don't have any channels data on this period.",
        'Select data source': 'Select data source',
        'Histogram Data Source': 'Histogram Data Source',
        'Histogram will be generated from a single selected data source.':
            'Histogram will be generated from a single selected data source.',
        'GOAL / KPI / Channel': 'GOAL / KPI / Canal',
        Settings: 'Settings',
        'Realtime cannot start because the selected well': 'Realtime cannot start because the selected well',
        'is being processed with the same event type': 'is being processed with the same event type',
        'in another Rig': 'in another Rig',
        'You must stop Realtime from the other Rig or change the name of the event type in':
            'You must stop Realtime from the other Rig or change the name of the event type in ',
        'Data Management': 'Data Management',
        'It is not possible to generate KPI in Realtime because the selected Well':
            'It is not possible to generate KPI in Realtime because the selected Well',
        'To enable Realtime processing in the present configuration, you must turn off Realtime in the':
            'To enable Realtime processing in the present configuration, you must turn off Realtime in the ',
        'already is associated with another Rig': 'already is associated with another Rig',
        'To enable Realtime processing in the present configuration, you must turn off Realtime in the':
            'To enable Realtime processing in the present configuration, you must turn off Realtime in the ',
        'Box Plot will be generated from a single selected data source.':
            'Box Plot will be generated from a single selected data source.',
        'Boxplot Data Source': 'Boxplot Data Source',
        'Second Quantile': 'Second Quantile',
        'First Quantile': 'First Quantile',

        // ML Screen KPI Options
        'KPI Datasource': 'KPI Datasource',
        'Data Aggregations': 'Data Aggregations',
        'interpolation-on': 'ON',
        'interpolation-off': 'OFF',
        'realtime-aggregation-on': 'ON',
        'realtime-aggregation-off': 'OFF',
        'The aggregator is used to compress Rig or Well data, being important for viewing channels in KPI dashboards. Enable Realtime compression on Data Aggregations tab of the asset (Rig or Well) chosen to generate KPI.':
            'The aggregator is used to compress Rig or Well data, being important for viewing channels in KPI dashboards. Enable Realtime compression on Data Aggregations tab of the asset (Rig or Well) chosen to generate KPI.',
        'Datasource Origin': 'Datasource Origin',
        'Input Event Type': 'Input Event Type',
        'Output Event Type': 'Output Event Type',
        'Real Time KPI Channels': 'Real Time KPI Channels',
        'KPI GENERATION METHODOLOGY': 'KPI GENERATION METHODOLOGY',
        "You need to configure Physical Models to generate Rig State events. This setting will affect the generation of KPI data, both in the 'KPI Detector by Rig States' and 'Adaptive KPI Detector (ML - Machine Learning)' methodology.":
            "You need to configure Physical Models to generate Rig State events. This setting will affect the generation of KPI data, both in the 'KPI Detector by Rig States' and 'Adaptive KPI Detector (ML - Machine Learning)' methodology.",
        'EVENT SPAN': 'EVENT SPAN',
        'Channels configurations': 'Channels configurations',
        'Last started on': 'Last started on',
        'Real Time will start from the beginning of the last detected stand. Real Time reprocessing period considers a maximum of 2 days backwards.':
            'Real Time will start from the beginning of the last detected stand. Real Time reprocessing period considers a maximum of 2 days backwards.',
        none: 'none',
        'No Process': 'No Process',
        'Checking status...': 'Checking status...',
        Running: 'Running',
        Error: 'Error',
        Initializing: 'Initializing',
        Start: 'Start',
        Stop: 'Stop',
        'Choose reprocessing span': 'Choose reprocessing span',
        'Choose span': 'Choose span',
        'No Reprocess': 'No Reprocess',
        'Generating KPI data.': 'Generating KPI data.',
        "It's not possible to configure channels while Real Time is Running. You need to stop Real Time to access Channels Configurations.":
            "It's not possible to configure channels while Real Time is Running. You need to stop Real Time to access Channels Configurations.",
        "It's not possible to configure channels while Reprocessing. You need to stop Reprocessing or wait for it to finish to access Channels Configurations.":
            "It's not possible to configure channels while Reprocessing. You need to stop Reprocessing or wait for it to finish to access Channels Configurations.",
        'Tubular will be finished with changes applied to tubular type and/or restricted performance':
            'Tubular will be finished with changes applied to tubular type and/or restricted performance',
        'Are you sure you want to update and finish the tubular event':
            'Are you sure you want to update and finish the tubular event',
        'Reprocessing KPI Channels': 'Reprocessing KPI Channels',
        "It's not possible to reprocess the chosen period. There is a stand being processed on realtime. It's possible to reprocess until":
            "It's not possible to reprocess the chosen period. There is a stand being processed on realtime. It's possible to reprocess until",
        'No data period at the selected span': 'No data period at the selected span',
        'Failed to initialize Rig state query.': 'Failed to initialize Rig state query.',
        'Failed to initialize StateMachineManager: The provided data provider is invalid or null.':
            'Failed to initialize StateMachineManager: The provided data provider is invalid or null.',
        'Failed to create the StateMachineManager: Issues related to the state machine or event lobby.':
            'Failed to create the StateMachineManager: Issues related to the state machine or event lobby.',
        'Failed to create the StateMachineManager: Invalid output collection.':
            'Failed to create the StateMachineManager: Invalid output collection.',
        'Could not validate if has channels data on this period':
            'Could not validate if has channels data on this period',
        'Could not convert span to user timezone': 'Could not convert span to user timezone',
        CHANNELS: 'CHANNELS',
        'Stand Size Settings': 'Stand Size Settings',
        'Pup Joint Stand Size': 'Pup Joint Stand Size',
        'Pup Joint Detection Threshold': 'Pup Joint Detection Threshold',
        'Stand Size Thresholds': 'Stand Size Thresholds',
        'Values that define the tube size to be considered for creation and identification by stand size. The values for calculation correspond to the minimum and maximum percentages of the Pipe Length.':
            'Values that define the tube size to be considered for creation and identification by stand size. The values for calculation correspond to the minimum and maximum percentages of the Pipe Length.',
        'pipe length': 'pipe length',
        minimum: 'minimum',
        maximum: 'maximum',
        'Overlapping values not allowed.': 'Overlapping values not allowed.',
        'Required field.': 'Required field.',
        'NOTE: Any changes made to this setting will only affect reprocessing. To also apply in Real Time, it is necessary to restart plugin-kpis-drilling.':
            'NOTE: Any changes made to this setting will only affect reprocessing. To also apply in Real Time, it is necessary to restart plugin-kpis-drilling.',
        'Stand Size Settings': 'Stand Size Settings',
        'Stand Size Settings updated successfully': 'Stand Size Settings updated successfully',
        'Pup Joint Detection Settings updated successfully': 'Pup Joint Detection Settings updated successfully',
        // Riser Rig State Presets (OGP21-5070..5072, PR #1755) — finding 9 / ação A-9
        'The selected channel has an invalid mnemonic and cannot be used.':
            'The selected channel has an invalid mnemonic and cannot be used.',
        'Rig State Presets': 'Rig State Presets',
        'Standard Preset': 'Standard Preset',
        'Riser Preset': 'Riser Preset',
        'Riser Indicator Channel': 'Riser Indicator Channel',
        'Select a standard preset': 'Select a standard preset',
        'Select a riser preset': 'Select a riser preset',
        'Select a binary channel': 'Select a binary channel',
        'No Standard Preset selected — select one to be used when the Riser indicator channel is inactive or unmapped.':
            'No Standard Preset selected — select one to be used when the Riser indicator channel is inactive or unmapped.',
        'No Standard Preset selected — select one to enable rig status detection.':
            'No Standard Preset selected — select one to enable rig status detection.',
        'Without Riser Preset — detection will only use the Standard Preset.':
            'Without Riser Preset — detection will only use the Standard Preset.',
        'No channel mapped — operates with Standard Preset.': 'No channel mapped — operates with Standard Preset.',
        'No channel mapped — select one to activate Preset Riser and enable automatic switching between presets.':
            'No channel mapped — select one to activate Preset Riser and enable automatic switching between presets.',
        'Preset applied by default in rig state detection. It will be used whenever the Riser indicator channel is inactive, null, unmapped, or not configured.':
            'Preset applied by default in rig state detection. It will be used whenever the Riser indicator channel is inactive, null, unmapped, or not configured.',
        'Preset applied when the Riser indicator channel signals Riser operation. Requires a mapped indicator channel to enable automatic switching.':
            'Preset applied when the Riser indicator channel signals Riser operation. Requires a mapped indicator channel to enable automatic switching.',
        'Binary channel (0/1) indicating riser operation. Displays only binary channels mapped in the Channel Manager of this rig.':
            'Binary channel (0/1) indicating riser operation. Displays only binary channels mapped in the Channel Manager of this rig.',
        'Automatic mode active — switching between Standard Preset and Riser according to the indicated channel.':
            'Automatic mode active — switching between Standard Preset and Riser according to the indicated channel.',
        'Riser Preset not selected.': 'Riser Preset not selected.',
        'No Riser Channel (using Standard Preset).': 'No Riser Channel (using Standard Preset).',
        'Auto-switch active': 'Auto-switch active',
        'Select a Standard Preset before applying.': 'Select a Standard Preset before applying.',
        'The selected preset no longer exists on this rig. Reload the page and try again.':
            'The selected preset no longer exists on this rig. Reload the page and try again.',
        'Standard Preset and Riser Preset must be different presets.':
            'Standard Preset and Riser Preset must be different presets.',
        'The selected channel is not a binary (0/1) channel.': 'The selected channel is not a binary (0/1) channel.',
        'The selected channel is not mapped in the Channel Manager of this rig.':
            'The selected channel is not mapped in the Channel Manager of this rig.',
        'Could not save the Rig State Presets configuration.': 'Could not save the Rig State Presets configuration.',
        'Rig State Presets updated successfully': 'Rig State Presets updated successfully',
        'This change affects reprocessing. Restart the plugin-kpis-drilling to use it in Real Time as well.':
            'This change affects reprocessing. Restart the plugin-kpis-drilling to use it in Real Time as well.',
        'Minimum Stand Size': 'Minimum Stand Size',
        'of Pipe Length': 'of Pipe Length',
        'Restore Default': 'Restore Default',
        'Changes will only be applied to reprocessing made from now on. To apply this new configuration also in Real Time, it is necessary to restart the plugin-kpis-drilling.':
            'Changes will only be applied to reprocessing made from now on. To apply this new configuration also in Real Time, it is necessary to restart the plugin-kpis-drilling.',
        'Are you sure you want to change the settings?': 'Are you sure you want to change the settings?',
        'Determines whether or not a stand is created when the delta bit depth between two Rig State Connection is less than or equal to the Minimum Stand Size.':
            'Determines whether or not a stand is created when the delta bit depth between two Rig State Connection is less than or equal to the Minimum Stand Size.',
        'Enable this toggle to create Pup Joint Stand Size by Minimum Stand Size or disable to skip creation of the stand in this parameter.':
            'Enable this toggle to create Pup Joint Stand Size by Minimum Stand Size or disable to skip creation of the stand in this parameter.',
        'Value filled in the Minimum (>) Single field, in Stand Size Thresholds, which is equivalent to the maximum Pup Joint Detection Threshold.':
            'Value filled in the Minimum (>) Single field, in Stand Size Thresholds, which is equivalent to the maximum Pup Joint Detection Threshold.',
        'Value filled in the Minimum (>) Single field defines the Minimum Stand Size and the maximum Pup Joint Detection Threshold.':
            'Value filled in the Minimum (>) Single field defines the Minimum Stand Size and the maximum Pup Joint Detection Threshold.',
        'Enable this toggle to create Pup Joint Stand Size by Minimum Stand Size or disable to skip creation of this new stand.':
            'Enable this toggle to create Pup Joint Stand Size by Minimum Stand Size or disable to skip creation of this new stand.',
        'Compression Settings': 'Compression Settings',
        'Disabling this flag will turn off channel compression in the "KPI RIG STATE CHANNELS" widget on the 24h dashboard by disabling the pipes module @@assetWidgetOverrideFilter.':
            'Disabling this flag will turn off channel compression in the "KPI RIG STATE CHANNELS" widget on the 24h dashboard by disabling the pipes module @@assetWidgetOverrideFilter.',
        'You must restart the plugin after saving the configuration for the change to take effect.':
            'You must restart the plugin after saving the configuration for the change to take effect.',
        'At least one equipment (Hydratong, Hydraracker, or Top Drive) must be selected to start reprocessing.':
            'At least one equipment (Hydratong, Hydraracker, or Top Drive) must be selected to start reprocessing.',
        'Pipes Module': 'Pipes Module',
        'Ml disconnected. Waiting to reconnect.': 'Ml disconnected. Waiting to reconnect.',
        Disconnected: 'Disconnected',
        Completed: 'Completed',
        Initializing: 'Initializing',
        Running: 'Running',
        Connecting: 'Connecting',
        REPROCESSING: 'Reprocessing',
        Ready: 'Ready',
        OK: 'Ok',
        'Rigstate reprocess': 'Rigstate reprocess',
        ' This Runner App is already running': 'This Runner App is already running',
        'Initializing Reprocessing may take a few minutes.': 'Initializing Reprocessing may take a few minutes.',

        // RIG SUMMARY APP
        'Server local time': 'Server local time: ',
        'Search for a rig': 'Search for a rig',
        'Rig ID': 'Rig ID',
        'Asset Name': 'Asset Name',
        'Asset Type': 'Asset Type',
        Realtime: 'Realtime',
        'Input Rig State': 'Input Rig State',
        'Current Rig State': 'Current Rig State',
        'Last Rig State': 'Last Rig State',
        'Rig State Status': 'Rig State Status',
        Compression: 'Compression',
        RIG: 'RIG',
        WELL: 'WELL',
        ON: 'ON',
        OFF: 'OFF',
        ERROR: 'ERROR',
        VALID: 'VALID',
        showingKey: 'Showing',
        rigs: 'rigs',
        ofKey: 'of',
        atKey: 'at ',
        'The type and timestamp of the last received Rig State event that was utilized by the Rig State KPI generation algorithm':
            'The type and timestamp of the last received Rig State event that was utilized by the Rig State KPI generation algorithm',
        'Status ERROR indicates that no Rig State KPI and Rig State Draft Events have been generated for over 10 seconds. If the status is VALID, it indicates that a new event has been generated within the last 10 seconds':
            'Status ERROR indicates that no Rig State KPI and Rig State Draft Events have been generated for over 10 seconds. If the status is VALID, it indicates that a new event has been generated within the last 10 seconds',
        'Fetching error': 'Fetching error',
        "Live Rigs or backend Timezone wasn't got": "Live Rigs or backend Timezone wasn't got",

        // UNIFIER KPI DATABASE
        Loading: 'Loading',
        'KPI Data QAQC': 'KPI Data QAQC',
        'Data Status': 'Data Status',
        'All-Filter': 'All',
        'Active-Filter': 'Active',
        'Inactive-Filter': 'Inactive',
        'Asset-Filter': 'Asset Status',
        'Data Quality': 'Data Quality',
        'Data Quality Control': 'Data Quality Control',
        'Data Quality Timeline': 'Data Quality Timeline',
        'Data Quality Management': 'Data Quality Management',
        'timeline-by': 'by',
        'timeline-on': 'on',
        'data-persistence-to': 'to',
        'Request for approval has been made.': 'Request for approval has been made.',
        'Period for approval:': 'Period for approval:',
        Bronze: 'Bronze',
        Silver: 'Silver',
        Gold: 'Gold',
        'All Statuses': 'All Statuses',
        'Filter by': 'Filter by',
        'unification status': 'unification status',
        'Unification Status': 'Unification Status',
        'Unification Period': 'Unification Period',
        'Last Unification': 'Last Unification',
        'Last Unification By': 'Last Unification By',
        'Auto Data Unifier': 'Auto Data Unifier',
        'Data Unifier': 'Data Unifier',
        'Pending Change': 'Pending Change',
        'Input Event Type': 'Input Event Type',
        'input event type': 'input event type',
        'Output Event Type': 'Output Event Type',
        'output event type': 'output event type',
        'unified period': 'unified period',
        'pending data unification': 'pending data unification',
        'No data changes': 'No data changes',
        'timespan to unify': 'timespan to unify',
        'Date to Edit': 'Date to Edit',
        Start: 'Start',
        unify: 'unify',
        Unify: 'Unify',
        dismiss: 'dismiss',
        Dismiss: 'Dismiss',
        'Enable timespan selection': 'Enable timespan selection',
        'unify all': 'unify all',
        'The KPIs, static data and existing goals for the selected timespan, will be copied and unified as a single collection.':
            'The KPIs, static data and existing goals for the selected timespan, will be copied and unified as a single collection.',
        'Unified Data': 'Unified Data',
        Unified: 'Unified',
        Pending: 'Pending',
        Unifying: 'Unifying...',
        'Not Unified': 'Not Unified',
        Error: 'Error',
        'Data Changes': 'Data Changes',
        'Update Date': 'Update Date',
        'Change made': 'Change made:',
        Period: 'Period:',
        User: 'User:',
        'review-approved': 'approved',
        'timeline-dismissed': 'dismissed',
        'timeline-pending': 'pending',
        'timeline-pendings': 'pendings',
        'timeline-unified': 'unified',
        'timeline-period': 'Period',
        'Start Date': 'Start Date',
        'End Date': 'End Date',
        'Start and End Date': 'Start and End Date',
        unifyingKey: 'Unifying',
        'Search for an asset': 'Search for an asset',

        // GOALS VERSIONING
        'Goals Versioning': 'Goals Versioning',
        'Saved by': 'Saved by',
        'Versioned Goal Status': 'Versioned Goal Status',
        'Type of change': 'Type of change',
        Date: 'Date',
        'Changed by': 'Changed by',
        CREATION: 'CREATION',
        UPDATE: 'UPDATE',
        DELETION: 'DELETION',
        'Versioned Goals State': 'Versioned Goals State',
        'Total Goals': 'Total Goals',
        GLOBAL_GOAL: 'Global Goal',
        LOCAL_GOAL: 'Local Goal',
        EDITED_GLOBAL_GOAL: 'Global Goal Edited',

        // KPI Options
        'RIG STATE PRESETS': 'RIG STATE PRESETS',
        'Rig state presets are available and configurable on rig models configuration.':
            'Rig state presets are available and configurable on rig models configuration.',

        // Omission KPI
        'New Rule': 'New Rule',
        'Edit Rule': 'Edit Rule',
        'New Omission Rule': 'New Omission Rule',
        'Rules list': 'Rules list',
        'Rule Name': 'Rule Name',
        'Search Rules': 'Search Rules',
        'Rule Status': 'Rule Status',
        'LAST UPDATE': 'LAST UPDATE',
        'Available assets': 'Available assets',
        'Added assets': 'Added assets',
        'Search rig': 'Search rig',
        'Length bit depth': 'Delta Bit Depth (End Bit depth - Begin Bit depth)',
        'Omission KPI': 'Omission KPI',
        Indicator: 'Indicator',
        'KPI Indicator': 'KPI Indicator',
        'Kpi Indicator': 'Kpi Indicator',
        Value: 'Value',
        Begin: 'Begin',
        BEGIN: 'BEGIN',
        Speed: 'Speed',
        Section: 'Section',
        Tatic: 'Intervention Tactic',
        'Rig Table Status': 'Rig Table Status',
        Responsible: 'Responsible',
        'Stand type': 'Stand type',
        'Stand size': 'Stand size',
        'Stand Count': 'Stand Size',
        'Stand count': 'Stand size',
        'Stand status': 'Stand status',
        'Run Type': 'Run Type',
        'Material type': 'Tubular Material Type',
        'Connection Type': 'Tubular Connection Type',
        'Tubular Type': 'Tubular Type',
        'Section OD': 'Section OD',
        'Hole Status': 'Hole Status',
        'Intervention Tatic': 'Intervention Tatic',
        'Rig Table Status': 'Rig Table Status',
        greaterThan: 'Greater than',
        lessThan: 'Less than',
        equals: 'Equals',
        notEquals: 'Not equals',
        greaterOrEquals: 'Greater or equals',
        lessOrEquals: 'Less or equals',
        ruleDescriptionP1:
            'A rule determines which KPIs will be omitted from calculations and visualizations. The rule applies to the unified KPI, which must be reprocessed in the desired period for the rule to take effect. Omitted KPIs remain in the unified KPIs collection, but will not be displayed in dashboards such as "Dynamic Chart" and "RPI management".',
        ruleDescriptionP2:
            'The rule works by combining different conditional criteria. Enable the desired conditionals and choose the value and logical operator. Disabled conditionals will be disregarded in the omission rule. For example, if you create a rule to omit KPIs of type "S2S" with a duration greater than 30 minutes, and do not specify the "tubular type" field, all "S2S" KPIs with the specified duration will be omitted, regardless of the tubular type.',
        ruleDescriptionP3:
            'E.g.: KPI Indicator: Value ("S2S"); Operator logical ("Equals") and KPI Duration: Value ("30"); Operator logical (>).',
        'Superset Send Progress': 'Superset Send Progress',
        Loading: 'Loading',
        'Could not fetch send progress.': 'Could not fetch send progress.',
        Status: 'Status',
        'Rows Sent': 'Rows Sent',
        'The value in parentheses represents the number of Tripping Children rows included in the total.':
            'The value in parentheses represents the number of Tripping Children rows included in the total.',
        'Batches Sent': 'Batches Sent',
        Duration: 'Duration',
        'Unified Dashboard': 'Unified Dashboard',
        'Fleet Dashboard': 'Fleet Dashboard',
        Created: 'Created',
        Failed: 'Failed',

        // Fleet Overview filters
        'Critical path': 'Critical path',
        'Non critical path': 'Non critical path',
        'Last 30 days': 'Last 30 days',

        ...fleetOverviewEn,
        // Code Management & KPI Goals
        'Are you sure you want to restore this entry?': 'Are you sure you want to restore this entry?',
        Code: 'Code',
        'CodeManagement entry updated successfully.': 'CodeManagement entry updated successfully.',
        'Colors Settings': 'Colors Settings',
        Custom: 'Custom',
        'Delay Automatic Detection of KPIs': 'Delay Automatic Detection of KPIs',
        Description: 'Description',
        'Display Code': 'Display Code',
        'System Code': 'System Code',
        'Edit Code in Code Management': 'Edit Code in Code Management',
        'Entry restored successfully.': 'Entry restored successfully.',
        'Failed to update CodeManagement entry': 'Failed to update CodeManagement entry',
        'KPI Compressed Settings': 'KPI Compressed Settings',
        'KPI Event Type Settings': 'KPI Event Type Settings',
        'KPI Goals': 'KPI Goals',
        'KPI Goals Settings': 'KPI Goals Settings',
        'Logs Settings': 'Logs Settings',
        'Omission KPI': 'Omission KPI',
        RESTORE: 'RESTORE',
        'Restore Global Goal': 'Restore Global Goal',
        'RigState Channels Configuration': 'RigState Channels Configuration',
        'RigState Channels Settings': 'RigState Channels Settings',
        'Select...': 'Select...',
        unit: 'unit',

        // Dynamic Dashboard Send
        'Dynamic Dashboard Status': 'Dynamic Dashboard Status',
        'Displays the result of the latest data publication to Dynamic Dashboards':
            'Displays the result of the latest data publication to Dynamic Dashboards',
        Sending: 'Sending',
        Checking: 'Checking',
        'Send Single Rig': 'Send Single Rig',
        'Send All Rigs': 'Send All Rigs',
        'Send failed': 'Send failed',
        'The Unified to SQL plugin is unavailable. The send would be aborted by the server.':
            'The Unified to SQL plugin is unavailable. The send would be aborted by the server.',
        'The Superset integration plugin is unavailable. Data will be sent, but no dashboard will be created.':
            'The Superset integration plugin is unavailable. Data will be sent, but no dashboard will be created.',
        'Could not check plugin availability before sending.':
            'Could not check plugin availability before sending.',
        'Enter rig ID': 'Enter rig ID',
        Send: 'Send',
        Updated: 'Updated',
        'Already available': 'Already available',
        'Process Status': 'Process Status',
        'KPIs Found': 'KPIs Found',
        'Total KPIs identified in the selected period. Values in parentheses represent KPIs integrated into parent KPIs':
            'Total KPIs identified in the selected period. Values in parentheses represent KPIs integrated into parent KPIs',
        'KPIs Sent': 'KPIs Sent',
        'Total KPIs successfully published to Dynamic Dashboards. Values in parentheses represent KPIs integrated into parent KPIs.':
            'Total KPIs successfully published to Dynamic Dashboards. Values in parentheses represent KPIs integrated into parent KPIs.',
        'Dashboard Status': 'Dashboard Status',
        Details: 'Details',
        'Unknown error': 'Unknown error',
        'No send operation in progress.': 'No send operation in progress.',
        'No unified KPIs found for the selected filter.': 'No unified KPIs found for the selected filter.',
        'Searching for unified KPIs to send': 'Searching for unified KPIs to send',
        'Could not load the rig list.': 'Could not load the rig list.',
        'Extent': 'Extent',
        'month': 'month',
        'months': 'months',
        'ALL RIGS': 'ALL RIGS',
        'This removes unified KPI data for every rig, across': 'This removes unified KPI data for every rig, across',
        'I understand this affects every rig.': 'I understand this affects every rig.',
        'Time window': 'Time window',
        'Mode': 'Mode',
        'Between two dates': 'Between two dates',
        'Everything before': 'Everything before',
        'Everything after': 'Everything after',
        'Before': 'Before',
        'After': 'After',
        'All rigs': 'All rigs',
        'all rigs': 'all rigs',
        'rig': 'rig',
        'Preview window': 'Preview window',
        'Resolving': 'Resolving',
        'Window': 'Window',
        'Scope': 'Scope',
        'Send window': 'Send window',
        'Delete window': 'Delete window',
        'Deleting': 'Deleting',
        'Delete failed': 'Delete failed',
        'The start date is after the end date.': 'The start date is after the end date.',
        'No unified data found for the selected scope.': 'No unified data found for the selected scope.',
        'The resolved window is empty: no unified data on that side of the date.': 'The resolved window is empty: no unified data on that side of the date.',
        'Could not resolve the time window.': 'Could not resolve the time window.',
        'One edge was resolved from the existing data.': 'One edge was resolved from the existing data.',
        'Remove all unified KPI data in the window below.': 'Remove all unified KPI data in the window below.',
        'This action cannot be undone.': 'This action cannot be undone.',
        'Are you sure you want to complete this action?': 'Are you sure you want to complete this action?',
        'Attention!': 'Attention!',
        'Confirm': 'Confirm',
        'Cancel': 'Cancel',
        'The Unified to SQL plugin is unavailable.': 'The Unified to SQL plugin is unavailable.',
        'You need the OGPERFORMANCE_MANAGE_KPI or OGPERFORMANCE_ADMINISTRATE_KPI authority.':
            'You need the OGPERFORMANCE_MANAGE_KPI or OGPERFORMANCE_ADMINISTRATE_KPI authority.',
        // OGP21-5245 UI: make the data destination explicit (Superset database, not Live)
        'Publishes and removes the unified KPIs in the Superset database (dashboards). It does not change Live data.':
            'Publishes and removes the unified KPIs in the Superset database (dashboards). It does not change Live data.',
        'Publishes the unified KPIs to the Superset database (dashboards). Does not change Live.':
            'Publishes the unified KPIs to the Superset database (dashboards). Does not change Live.',
        'Removes the unified KPI data published to Superset (dashboards) in the window below. It does not remove anything from Live.':
            'Removes the unified KPI data published to Superset (dashboards) in the window below. It does not remove anything from Live.',
        'This removes unified KPI data for every rig, {window}.':
            'This removes unified KPI data for every rig, {window}.',
        'This removes unified KPI data for every rig, across {count} {unit}.':
            'This removes unified KPI data for every rig, across {count} {unit}.',
        // OGP21-5245 UI: keys the screen used but no locale defined (fell back to English)
        'Only KPIs entirely on that side of the date are removed; a KPI that crosses it is kept.':
            'Only KPIs entirely on that side of the date are removed; a KPI that crosses it is kept.',
        'Collection Name': 'Collection Name',
        'Not available': 'Not available',
        'Not modified': 'Not modified',
        'Skipped': 'Skipped',
        'Legacy tables': 'Legacy tables',
        'rows removed': 'rows removed',
        'dropped': 'dropped',
        'kept': 'kept',
        'views': 'views',
        'Partitions dropped': 'Partitions dropped',
        'Choose date': 'Choose date',
        'Hour:': 'Hour:',
        // OGP21-5245 UI F-01: stall guard
        'The send status stopped updating. It may have finished — check now to confirm.':
            'The send status stopped updating. It may have finished — check now to confirm.',
        'Check now': 'Check now',
        // OGP21-5245 UI F-03: action feedback
        'Send requested. Follow the progress below.': 'Send requested. Follow the progress below.',
        'Delete requested. Follow the progress below.': 'Delete requested. Follow the progress below.',
        // OGP21-5245 UI PR-01/S-02/S-03: progress bar and fleet-send confirmation
        '{completed} of {total} periods': '{completed} of {total} periods',
        '{failed} failed': '{failed} failed',
        'This publishes the unified KPIs for all rigs to the Superset database (dashboards). It does not change Live.':
            'This publishes the unified KPIs for all rigs to the Superset database (dashboards). It does not change Live.',
        'Rigs with unified data: {count}': 'Rigs with unified data: {count}',
        // OGP21-5245 UI C-04/P-01: scope label and rig-list loading
        'rig {name}': 'rig {name}',
        'Loading rigs': 'Loading rigs',
        // OGP21-5245 UI S-05/S-04: empty-state hint and timestamp timezone note
        'Try widening the time window or run a Preview window.':
            'Try widening the time window or run a Preview window.',
        'Shown in your local time zone.': 'Shown in your local time zone.',
        // OGP21-5245 R10 — dynamic dashboard status: goal timestamps, no_op, refresh warning
        'Global goals last updated': 'Global goals last updated',
        'goals last updated': 'goals last updated',
        'No goals of its own (uses Global)': 'No goals of its own (uses Global)',
        'Goals changed after this send started. Send again to apply them.': 'Goals changed after this send started. Send again to apply them.',
        'Do not refresh the Superset dashboard until this operation is COMPLETED.': 'Do not refresh the Superset dashboard until this operation is COMPLETED.',
        'Result': 'Result',
        'Last send started': 'Last send started',
        'Could not load the goals last-updated times.': 'Could not load the goals last-updated times.',
        'No rig had unified KPIs for the requested rig or window.': 'No rig had unified KPIs for the requested rig or window.',
        'Every period failed: nothing was written or removed.': 'Every period failed: nothing was written or removed.',
        'The periods were processed but no row was written, so there was nothing to refresh.': 'The periods were processed but no row was written, so there was nothing to refresh.',
        'The delete found nothing to remove in the requested window.': 'The delete found nothing to remove in the requested window.'
    }
}
